import { createContext } from 'react';

const ToasterContext = createContext({});

export default ToasterContext;
